const SANTANDER_CLABE_ACTIONS = {
  ASSIGN: 'ASSIGN',
  UNASSIGN: 'UNASSIGN'
};

export default SANTANDER_CLABE_ACTIONS;